export default __webpack_public_path__ + "static/media/0216.b9002eb0.jpg";